module.exports = __webpack_public_path__ + "static/danielle-hall-915f0818cfd7d48782c3463d433ca8f9.jpg";